export enum LoaderStatusEnum {
    'BYPASS_FULL_LOADER' = 'bypass_full_loader',
}
